import React, { useRef, useState, useEffect, useContext } from "react";
import { finalTranslations } from "../../localTranslation";
import clsx from "clsx";
import styles from "./CardFooter.module.css";
import { votingApi } from "../../helpers/fetcher";
import styled from "styled-components";
import { ACTIONS } from "../../store/Actions";
import { DataContext } from "../../store/GlobalState";
import { EditButton } from "../CardHeader";
import g2 from "./g2.png";
const CardFooter = ({
  lang,
  onOpenPhenEditCard,
  canEditContentCard,
  data,
  gid,
  isTranslated,
  langForTransState,
  // lastesEditor
}) => {
  const cardBodyRef = useRef();
  const cardBodyRef2 = useRef();


  const {
    state: { getTheWholeCardHtmlElms, isAutoTrans, isLoading },
    dispatch,
  } = useContext(DataContext);

  const [translations, settranslations] = useState(null);
  const [originalTitle, setoriginalTitle] = useState(null);


  useEffect(() => {
    const fetcher = async () => {
      const res1 = (originalTitle ||  cardBodyRef2?.current) && await votingApi.translation(
        "en",
        langForTransState,
        originalTitle ?? cardBodyRef2?.current 
      );
      settranslations(() => {
        return {
          res1,
        };
      });
    };
    !!isTranslated && (originalTitle ||  cardBodyRef2?.current) && fetcher();
  }, [isTranslated, originalTitle, langForTransState]);

  useEffect(() => {
    if (!!canEditContentCard) {
      if (true) {
        if (!cardBodyRef2?.current && !!cardBodyRef.current?.innerHTML) {
          cardBodyRef2.current = cardBodyRef.current?.innerHTML
        }
        (!!cardBodyRef2?.current ) && setoriginalTitle(() => cardBodyRef2?.current);
        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD3,
        //   payload: true,
        // });
      }
    }
  }, [isTranslated, canEditContentCard, dispatch]);

  return (
    <div className={styles.cardFooterWrapper}>
      {!!canEditContentCard && (
        <div>
          <EditBtn
            id="edit-phenomenon-btn"
            disabled={isLoading}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              opacity: !isLoading ? 1 : 0
            }}
            onClick={onOpenPhenEditCard}
            className={
              styles.editPhenomenonBtn + " btn btn-sm btn-outline-secondary "
            }
          >
            <span className={clsx(styles.pencilIcon, "af-custom-edit")}></span>
            {/* EDIT PHENOMENON */}
            {!isTranslated && (
              <div ref={cardBodyRef}>
                {lang === "fi"
                  ? finalTranslations?.editPhenomenon?.fi.toUpperCase()
                  : finalTranslations?.editPhenomenon?.en.toUpperCase()}
              </div>
            )}
            {!!isTranslated && (
              <div
                style={{
                  textTransform: "uppercase",
                }}
                ref={cardBodyRef}
                dangerouslySetInnerHTML={{ __html: translations?.res1?.data }}
              ></div>
            )}
          </EditBtn>
        </div>
      )}
      {!!isTranslated && (
        <EditButton
          style={{
            height: 15,
            margin: 0,
            marginTop: "24px",
          }}
          className={
            styles.editPhenomenonBtn + " btn btn-sm btn-outline-secondary "
          }
          onClick={onOpenPhenEditCard}
          src={g2}
        />
      )}
    </div>
  );
};

export default CardFooter;

const EditBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent !important;
  &:hover {
    background-color: #006998 !important;
  }
`;
